<template>
    <div class="relative mb-[16px]">
        <div :class="['absolute h-full w-[12.5px] left-0 top-0 border-r z-[-1] border-r-[#0c5ccf]',{'hidden':islast}]"/>
            <div class="flex items-center gap-x-[16px]">
                <div class="flex items-center border-[3px] border-white justify-center bg-[#0c5ccf] size-[25px] rounded-full">
                    <Check color="#ffffff" :size="16" strokeWidth="1.5"/>
                </div>
                <div class="font-light flex items-center gap-x-[16px]">
                    <span class="font-extralight">{{ contrat.pivot.end ? formatDate2(contrat.pivot.start+"T"+(contrat.pivot.end)) : formatDate(contrat.pivot.start) + " à aujourd'hui" }}</span>
                    <span>---</span>
                    <span>{{ contrat.label }} ({{ contrat.pivot.contract_type }})</span>
                </div>
            </div>
    </div>
</template>
<script>
import { Check } from 'lucide-vue-next';
import { advancedFormat,convertirDateEnFrancais } from '@/utils/date-format';
export default {
    name: "ContractStory",
    components: {Check},
    props:['contrat','islast'],
    methods:{
        formatDate(date){return convertirDateEnFrancais(date)},
        formatDate2(date){
            const [date1,date2] = date.split('T');
            return advancedFormat(date1,date2);
        }
    }
}
</script>